module.exports = __webpack_public_path__ + "static/media/va-endslide.ecdd1a67.svg";